import type { LabelHydraItem } from "@verbleif/lib/src/composables/Api/Type/Label/label.interface";
import type { CrudArgs } from "./composables/ContextVoter";
import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export type LabelEntityVote = Pick<LabelHydraItem, "location" | "client" | "source"> & {
  "@id"?: string
};

interface LabelVoterInterface extends Omit<ContextVoterInterface, "canUpdate" | "canDelete"> {}

export class LabelVoter extends ContextVoter implements LabelVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationLabelCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationLabelCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationLabelReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationLabelRead,
    });
  };

  public canUpdate(item: LabelEntityVote): boolean {
    if (item.source !== "manual") {
      return false;
    }

    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationLabelUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationLabelUpdate,
    });
  }

  public canDelete(item: LabelEntityVote): boolean {
    if (item.source !== "manual") {
      return false;
    }

    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationLabelDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationLabelDelete,
    });
  }

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationLabelCreateany,
        PermissionAttributesEnum.GlobalOperationLabelUpdateany,
        PermissionAttributesEnum.GlobalOperationLabelDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationLabelCreate,
        PermissionAttributesEnum.ContextOperationLabelUpdate,
        PermissionAttributesEnum.ContextOperationLabelDelete,
      ],
    });
  };

  public canAccess(item?: CrudArgs): boolean {
    return this._canCrud({
      item: item ?? {
        client: this.permissionService.defaultClient,
        location: this.permissionService.defaultLocation,
      },
      globalAttribute: PermissionAttributesEnum.GlobalOperationLabelReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationLabelRead,
    });
  }
}
